module.exports = __webpack_public_path__ + "img/beaver.fc57a011.png";